import config from 'react-global-configuration';
import queryString from 'query-string';
import Enzyme from 'enzyme';
import Adapter from 'enzyme-adapter-react-16';

export const getParamByName = (key) => {
    let uri = window.location.search;
    if (window.location.hash) {
        uri = window.location.href.split('?')[1];
    }

    const parsed = queryString.parse(uri);
    return parsed[key];
};

export function initialConfig() {
    const token = getParamByName('token');
    const backUrl = getParamByName('backUrl');
    const settings = Object.assign({}, window.pppAppConfig, { token, backUrl });
    if (!Object.prototype.hasOwnProperty.call(settings, 'MathleticsLibraryGatewayUrl')) {
        settings.MathleticsLibraryGatewayUrl = 'https://gateway-qa.3plearning.com/MathleticsLibraryGateway';
    }
    config.set({ ...settings }, { freeze: false });
    Enzyme.configure({ adapter: new Adapter() });
}

export const NUMBER_OF_LOADING_ITEMS = 36;
